<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">Agregar producto</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="formValido" lazy-validation>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Nombre del producto"
                :rules="reglas"
                required
                hide-details="auto"
                v-model="producto.nombre"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Descripción"
                :rules="reglas"
                required
                hide-details="auto"
                v-model="producto.descripcion"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Precio"
                :rules="reglas"
                type="number"
                required
                hide-details="auto"
                v-model="producto.precio"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Stock"
                :rules="reglas"
                type="number"
                required
                hide-details="auto"
                v-model="producto.stock"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Categoría"
                :rules="reglas"
                required
                hide-details="auto"
                v-model="producto.categoria"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-file-input
                label="Imagen"
                accept="image/*"
                prepend-icon="mdi-camera"
                v-model="producto.imagen"
                hide-details="auto"
                :placeholder="producto.imagenActual ? 'Cambiar imagen actual' : 'Seleccionar imagen (opcional)'"
              ></v-file-input>
              <div v-if="producto.imagenActual && !producto.imagen" class="mt-2">
                <small class="text-grey">Imagen actual:</small>
                <br>
                <img 
                  :src="urlImagen(producto.imagenActual)" 
                  alt="Imagen actual" 
                  style="max-width: 100px; max-height: 100px; object-fit: cover; border: 1px solid #ddd; border-radius: 4px;" 
                  class="mt-1"
                >
                <br>
                <small class="text-caption text-grey">
                  {{ producto.imagenActual.includes('default.jpg') ? 'Imagen por defecto' : 'Imagen personalizada' }}
                </small>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="cerrarDialogo">Cerrar</v-btn>
      <v-btn
        color="blue darken-1"
        text
        :disabled="!formValido"
        @click="registrar"
      >
        Registrar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import Utiles from '../../Servicios/Utiles'

export default {
  name: "FormProducto",
  props: ["producto"],
  data: () => ({
    formValido: false,
    reglas: [(value) => !!value || "Debes colocar este campo."]
  }),
  methods: {
    cerrarDialogo() {
      this.$emit("cerrado", false);
    },
    registrar() {
      this.$emit("registrar", this.producto);
    },
    urlImagen(imagen) {
      return Utiles.generarURL(imagen);
    }
  },
};
</script> 


// WEBPACK FOOTER //
// src/components/Productos/FormProducto.vue